import React, { useState } from 'react';

import { postFeedback } from "../api/api";
import { useAuth } from '../utils/AuthContext';
import CustomLoader from '../components/CustomLoader';

import { 
  Share2, 
  Copy, 
  Mail, 
  Facebook, 
  Twitter, 
  Linkedin, 
  Link2, 
  Check,
  X ,
  StarIcon
} from 'lucide-react';

const FeedbackModal = ({ onClose }) => {
  // State for tracking user feedback
  const [rating, setRating] = useState(0);
  const [suggestion, setSuggestion] = useState('');
  const [submittedFeedback, setSubmittedFeedback] = useState([]);
  const [isFeedModalOpen, setIsFeedModalOpen] = useState(false);
  
  const [loading, isLoading] = useState(false);
  const [submitted, isSubmitted] = useState(false);

  const [userRating, setUserRating] = useState(0);

  const { token } = useAuth();

  // Calculate satisfaction metrics
  const calculateSatisfactionMetrics = () => {
    const totalFeedback = submittedFeedback.length;
    const averageRating = submittedFeedback.reduce((sum, fb) => sum + fb.rating, 0) / totalFeedback || 0;
    
    const ratingDistribution = {
      1: submittedFeedback.filter(fb => fb.rating === 1).length,
      2: submittedFeedback.filter(fb => fb.rating === 2).length,
      3: submittedFeedback.filter(fb => fb.rating === 3).length,
      4: submittedFeedback.filter(fb => fb.rating === 4).length,
      5: submittedFeedback.filter(fb => fb.rating === 5).length,
    };

    return {
      totalFeedback,
      averageRating: averageRating.toFixed(1),
      ratingDistribution
    };
  };

  // Handle rating selection
  const handleRatingSelect = (selectedRating) => {
    setRating(selectedRating);
    setUserRating(selectedRating);
  };

  // Submit feedback
  const handleSubmitFeedback = async () => {
    if (rating > 0) {
      
      try {
        isLoading(true);
        const results = await postFeedback(token, rating, suggestion);
        
        setRating(0);
        setSuggestion('');
        isSubmitted(true);

      } catch (error) {
        console.error('Error submitting review:', error);
        isLoading(false);
      } finally {
        isLoading(false); 
      }
      
    }
  };

  // Satisfaction metrics
  //const metrics = calculateSatisfactionMetrics();

  // Render star icon
  const renderStar = (starRating) => {
    return (
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 24 24" 
        className={`w-6 h-6 cursor-pointer ${
          starRating <= rating 
            ? 'text-yellow-500 fill-current' 
            : 'text-grey-600'
        }`}
        onClick={() => handleRatingSelect(starRating)}
      >
        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
      </svg>
    );
  };


  return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div 
        className="bg-white w-96 rounded-2xl shadow-2xl p-6 relative animate-scale-in"
        role="dialog"
        aria-modal="true">
          {/* Close Button */}
          <button onClick={onClose}
            className="absolute top-4 right-4 text-gray-600 hover:text-gray-900">
            <X className="w-6 h-6" />
          </button>

          {/* Modal Content */}
          <h2 className="text-xl font-bold mb-4"> How is Tuly ?</h2>

          {/* Rating Section 
          <div className="mb-4">
            <h3 className="text-lg font-semibold mb-2">Rate it</h3>
            <div className="flex items-center space-x-2">
              {[1, 2, 3, 4, 5].map((starRating) => renderStar(starRating))}
            </div>
          </div>*/}

          <div className="mb-4">
            <h3 className="text-lg font-semibold mb-2">Star rate </h3>
            <div className="flex items-center space-x-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <StarIcon
                  key={star}
                  className={`w-8 h-8 cursor-pointer ${
                    star <= userRating
                      ? 'text-yellow-400 fill-yellow-400'
                      : 'text-gray-300'
                  }`}
                  onClick={() => handleRatingSelect(star)}
                />
              ))}
            </div>
          </div>

          {/* Suggestion Textarea */}
          <div className="mb-4">
            <h3 className="text-lg font-semibold mb-2">What do you think about HUBBR ?</h3>
            <textarea
              value={suggestion}
              onChange={(e) => setSuggestion(e.target.value)}
              placeholder="What can we improve? Share your ideas..."
              className="w-full border rounded p-2"
              rows={4}
            />
          </div>

          {/* Submit Button */}
          <button 
            onClick={handleSubmitFeedback} 
            disabled={rating === 0 || submitted || loading}
            className={`w-full py-2 rounded transition-colors duration-200 ${
              submitted 
                ? "bg-green-600 hover:bg-green-700" 
                : "bg-blue-600 hover:bg-blue-700"
            } text-white disabled:opacity-50`}
          >
            {loading 
              ? <CustomLoader size="small" /> 
              : (submitted 
                  ? <div className="flex items-center justify-center space-x-1">
                      <Check className="w-5 h-5" />
                      <span>Done</span>
                    </div> 
                  : "Submit Feedback"
                )
            }
          </button>

        </div>
      </div>
    
  );
};

export default FeedbackModal;